import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import rootSaga from "./rootSaga";

// Reducers
import dashboardReducer from "../redux/Dashboard/dashboardSlice";
import notificationReducer from "../redux/Notification/notificationSlice";
import sellReducer from "../redux/Sell/sellSlice";
import profileReducer from "../redux/Profile/profileSlice";
import giftReducer from "../redux/Gifts/giftSlice";
import redeemReducer from "../redux/Redeem/redeemSlice";
import passbookReducer from "../redux/Passbook/passbookSlice";
import sipReducer from "../redux/Sip/sipSlice";
import offlineOrderReducer from "../redux/OfflineOrder/offlineOrderSlice";
import productReducer from "../redux/Products/productSlice";
import productOrderReducer from "../redux/ProductOrder/productOrderSlice"
import diamondPointReducer from "../redux/DiamondPoint/DiamondPointSlice";
import onlineOrderReducer from "../redux/OnlineOrder/onlineOrderSlice";
import depositReducer from "../redux/DepositePlan/depositeSlice";
import customerInteractionReducer from "../redux/CustomerInteraction/customerInteractionSlice"
import muhuratReducer from "./MuhuratCalender/muhuratSlice";
import jewelleryReducer from "./Jewellery/jewellerySlice";
import jewelleryCartReducer from "./Jewellery/jewelleryCartSlice";
// Reset constant
const RESET_STORE = "RESET_STORE";

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  notification: notificationReducer,
  sell: sellReducer,
  profile: profileReducer,
  gift: giftReducer,
  redeem: redeemReducer,
  passbook: passbookReducer,
  sip:sipReducer,
  offline_order: offlineOrderReducer,
  product: productReducer,
  productOrder: productOrderReducer,
  diamondPoint:diamondPointReducer,
  onlineOrder:onlineOrderReducer,
  deposit:depositReducer,
  customerInteraction:customerInteractionReducer,
  muhurat: muhuratReducer,
  jewellery: jewelleryReducer,
  jewelleryCart: jewelleryCartReducer,
});
const appReducer = rootReducer;

const resettableReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: hardSet,
  whitelist: ["dashboard", "notification", "sell", "redeem", "gift","profile", "passbook","sip", "offlineOrder","diamondPoint","onlineOrder","productOrder","product","deposit","customerInteraction","muhurat", "jewellery"],
};

const persistedReducer = persistReducer(persistConfig, resettableReducer);

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
  devTools: true,
});

// Run saga
sagaMiddleware.run(rootSaga);

// Create persistor
export const persistor = persistStore(store);
